"use client";

import React from "react";
import { Target, Compass, Layers, Zap } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const focusPoints = [{
  title: "Esprit de Champion",
  description: "Nous cultivons le goût de l'effort et le dépassement de soi à travers des compétitions stimulantes pour tous les niveaux.",
  icon: Target
}, {
  title: "Organisation Pro",
  description: "Une logistique adapté pour que chaque enfant, amateur ou élite, se sente comme un joueur majeur.",
  icon: Layers
}, {
  title: "Rayonnement Mondial",
  description: "Des compétitions locales aux tournois internationaux pour élargir les horizons.",
  icon: Compass
}, {
  title: "Valeurs & Fair-Play",
  description: "Le respect, la camaraderie et l'éthique sportive unissent nos participants à chaque coup de sifflet.",
  icon: Zap
}];
export default function DajamsApproach() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="225569" id="lesprit-kickoff-events" ref={sectionRef} className="relative overflow-hidden bg-background py-24 lg:py-32">
      {}
      <div className={`absolute -right-[20%] top-1/2 -translate-y-1/2 w-[800px] h-[800px] opacity-[0.05] pointer-events-none transition-all duration-1000 ease-out ${sectionVisible ? 'scale-100' : 'scale-95'}`} aria-hidden="true">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647492/img/kickoff_events_trophy_watermark.png" alt="" className="w-full h-full object-contain" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24 items-start">
          
          {}
          <div ref={leftRef} className={`lg:col-span-5 lg:sticky lg:top-32 transition-all duration-700 ease-out ${leftVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <span className="text-primary font-bold tracking-widest uppercase text-sm mb-6 block font-default">
              L'Esprit Kickoff
            </span>
            <h2 className="text-5xl md:text-6xl lg:text-7xl font-default font-light text-foreground leading-[1.1] tracking-tighter">
              Notre<br />
              <span className="font-bold text-primary italic">Philosophie</span>
            </h2>
            <div className="w-20 h-1 bg-primary mt-8 rounded-none"></div>
          </div>

          {}
          <div ref={rightRef} className={`lg:col-span-7 transition-all duration-700 delay-200 ease-out ${rightVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <div className="prose prose-lg dark:prose-invert max-w-none mb-16">
              <p className="text-xl md:text-2xl text-foreground leading-relaxed font-default font-medium">
                Nous transformons chaque terrain en un théâtre de passions partagées. Chez Kickoff Events, nous créons des événements inspirants où chaque jeune joueur peut vivre son rêve de football.
              </p>
              <p className="text-lg text-muted-foreground leading-relaxed font-default mt-6">
                Notre organisation rigoureuse offre un cadre de niveau professionnel accessible à tous, garantissant une aventure humaine et sportive unique, placée sous le signe du dépassement de soi et du fair-play.
              </p>
            </div>

            {}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {focusPoints.map((point, i) => <div data-index={i} key={i} className="h-full">
                  <Card className="h-full bg-secondary/40 backdrop-blur-md border-border/40 shadow-lg hover:border-primary/50 transition-all duration-300 rounded-none">
                    <CardHeader className="pb-2 flex flex-row items-center gap-4">
                      <div className="w-10 h-10 rounded-none bg-primary/10 flex items-center justify-center shrink-0">
                        <point.icon className="w-5 h-5 text-primary" />
                      </div>
                      <CardTitle className="text-lg font-default font-bold uppercase tracking-tight m-0">{point.title}</CardTitle>
                    </CardHeader>
                    <CardContent>
                      <p className="text-muted-foreground text-sm font-default leading-relaxed">
                        {point.description}
                      </p>
                    </CardContent>
                  </Card>
                </div>)}
            </div>
          </div>

        </div>
      </div>
    </section>;
}